const optionalString = (value) => value === null || value === undefined ? "" : String(value);

export const normalizeDeployerPage = (payload) => ({
    count: Number(payload?.count) || 0,
    next: payload?.next || null,
    previous: payload?.previous || null,
    results: Array.isArray(payload?.results) ? payload.results : [],
});

export const emptyDeployerForm = () => ({
    username: "",
    password: "",
    phone_number: "",
    email: "",
    name: "",
    note: "",
    commission_percent: "",
});

export const mapDeployerToForm = (deployer = {}) => ({
    username: optionalString(deployer.username),
    phone_number: optionalString(deployer.phone_number),
    email: optionalString(deployer.email),
    name: optionalString(deployer.name),
    note: optionalString(deployer.note),
    commission_percent: optionalString(
        deployer.commission_percent === 0 || deployer.commission_percent
            ? deployer.commission_percent
            : "",
    ),
});

export const deployerQueryKeys = {
    all: ["admin-deployers"],
    list: ({countryId, page, search, pageSize}) => ["admin-deployers", "list", String(countryId ?? ""), page, search || "", Number(pageSize) || 20],
    detail: ({deployerId, countryId}) => ["admin-deployers", "detail", deployerId, String(countryId ?? "")],
};

export const parsePageFromPaginationUrl = (url, fallback = 1) => {
    if (!url) return fallback;
    try {
        const page = Number(new URL(url, window.location.origin).searchParams.get("page"));
        return Number.isInteger(page) && page > 0 ? page : fallback;
    } catch (_error) {
        return fallback;
    }
};
